import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const excelConnectorSelector = (state: IAppState) => state.excelConnector;


export const getCurrentExcelConnector = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorCurrent.connector
);

export const getCurrentExcelConnectorDetailVersion = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorCurrent.connector.versionDetail
);

export const getCurrentExcelConnectorIsLoading = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorCurrent.isLoading
);

export const getCurrentExcelConnectorIsUploading = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorCurrent.isUploading
);

export const getFileNameConnectorDetail = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorCurrent.uploadedFileName
);
